/**
 * personnel.js
 * ------------
 * Fiche agent : absences et contrats du personnel.
 *
 * Extrait de `directeurApi.js` (559 lignes, toutes les fonctions ajoutees a la
 * suite). Chaque lot ajoutait ses appels en fin de fichier : deux lots ouverts
 * en meme temps entraient donc systematiquement en conflit sur ce fichier.
 * `directeurApi.js` reste le point d'entree — il re-exporte ces modules — pour
 * qu'aucun ecran n'ait a changer ses imports.
 */
import axiosClient from "../axiosClient";

/* ── Fiche agent (personnel) ── */

/** GET /rh/absences/?employe=<id> — absences déclarées d'un membre du personnel. */
export async function getAbsencesPersonnel(employeId) {
  const { data } = await axiosClient.get("/rh/absences/", { params: { employe: employeId } });
  return Array.isArray(data) ? data : data?.results || [];
}

/** GET /rh/contrats/?employe=<id> — contrats d'un membre du personnel. */
export async function getContratsPersonnel(employeId) {
  const { data } = await axiosClient.get("/rh/contrats/", { params: { employe: employeId } });
  return Array.isArray(data) ? data : data?.results || [];
}

/** GET /directeur/staff/<id>/service/ -> service hebdomadaire d'un enseignant.
 *  `semaine` accepte n'importe quelle date : la semaine retenue la contient. */
export async function getServiceEnseignant(id, semaine) {
  const { data } = await axiosClient.get(`/directeur/staff/${id}/service/`, {
    params: semaine ? { semaine } : {},
  });
  return data || {};
}
